var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGerman = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fc0",
  d: "M0 320h640v160H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000001",
  d: "M0 0h640v160H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M0 160h640v160H0z"
})));
export { SvgGerman as ReactComponent };
export default __webpack_public_path__ + "assets/images/german.4887296465f7e194effdbff2b1038d49.svg";